import { type ReactNode } from 'react';

export interface AuthCardProps {
    title: string;
    subtitle?: string;
    children: ReactNode;
    footer?: ReactNode;
}

/** Centered card used by the credential / password / 2FA screens. */
export function AuthCard({ title, subtitle, children, footer }: AuthCardProps) {
    return (
        <div className="auth-page">
            <div className="auth-card">
                <h1 className="h4 mb-1">{title}</h1>
                {subtitle && <p className="text-body-secondary mb-4">{subtitle}</p>}
                {children}
                {footer && <div className="mt-3">{footer}</div>}
            </div>
        </div>
    );
}
